import { limitLength } from '@angle/utils'
import React, { useContext, useMemo, useState } from 'react'
import { Button, Form } from 'react-angle-dashboard-components'
import { useHistory, useLocation } from 'react-router-dom'
import {
  MAX_ASNWER_WIDTH,
  PRIMARY_COLOR,
  QuestionContainer
} from '../../components/Question'
import { useStep } from '../../hooks'
import { GbsStore } from '../../store'

const stepKey = 'zipCode'

export const ZipCode = () => {
  const history = useHistory()

  const token =
    new URLSearchParams(useLocation().search).get('token') || undefined

  const { dispatch } = useContext(GbsStore)
  const [value, setValue] = useState<Number | undefined>()

  const stepConfig = useMemo(() => {
    return {
      topBar: {
        completedPercentage: 0
      },
      bottomBar: {
        hidden: true
      }
    }
  }, [])

  useStep(stepKey, stepConfig, dispatch)

  const onContinue = () => {
    if (!value) return

    history.push(`/?zip=${value}${token ? `&token=${token}` : ''}`)
  }

  const isDisabled = !value

  return (
    <QuestionContainer>
      <div style={{ width: '60%', margin: '0 auto', textAlign: 'center' }}>
        <h1 style={{ fontFamily: 'Sentinel' }}>Enter your Zip Code</h1>
        <Form.Group style={{ width: '130px', margin: '3rem auto 0 auto' }}>
          <Form.Control
            value={value?.toString()}
            className="bg-white"
            type="text"
            placeholder="Zip Code"
            onChange={(e) => limitLength(e, 5, setValue)}
            size="lg"
            style={{
              maxWidth: MAX_ASNWER_WIDTH,
              border: `2px solid ${value ? PRIMARY_COLOR : 'var(--gray-400)'}`,
              color: value ? PRIMARY_COLOR : 'var(--gray-400)'
            }}
          />
        </Form.Group>
        <div className="text-center mt-5">
          <Button
            style={{ width: 130 }}
            variant="primary"
            onClick={onContinue}
            disabled={isDisabled}
          >
            Next
          </Button>
        </div>
      </div>
    </QuestionContainer>
  )
}

export default ZipCode
